/* WORKSWEAR: Browser-Merkliste (Bookmarks) + Likes + Header-Modal (localStorage, ohne Login) */
(function () {
  var BM_KEY = 'ws_wishlist'; // gemerkte Produkte (Bookmarks) – Array von Handles
  var LK_KEY = 'ws_likes';    // Likes – Objekt { handle: count }

  /* ---------- Storage-Helfer ---------- */
  function bmGet() { try { return JSON.parse(localStorage.getItem(BM_KEY)) || []; } catch (e) { return []; } }
  function bmSet(a) { localStorage.setItem(BM_KEY, JSON.stringify(a)); updateCounts(); }
  function bmHas(h) { return bmGet().indexOf(h) > -1; }
  function bmToggle(h) {
    var a = bmGet(); var i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); } else { a.push(h); }
    bmSet(a);
    return i === -1; // true = neu hinzugefügt
  }

  function lkGet() { try { return JSON.parse(localStorage.getItem(LK_KEY)) || {}; } catch (e) { return {}; } }
  function lkSet(o) { localStorage.setItem(LK_KEY, JSON.stringify(o)); }
  function lkCount(h) { return lkGet()[h] || 0; }
  function lkToggle(h) {
    var o = lkGet();
    if (o[h]) { delete o[h]; } else { o[h] = 1; }
    lkSet(o);
    return !!o[h]; // true = jetzt geliked
  }

  /* ---------- Zähler aktualisieren ---------- */
  function updateCounts() {
    var n = bmGet().length;
    document.querySelectorAll('[data-ws-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function lkText(c) { return c > 0 ? String(c) : ''; }

  /* ---------- Buttons synchronisieren ---------- */
  function syncButtons(root) {
    var r = root || document;
    r.querySelectorAll('.ws-bookmark-btn').forEach(function (btn) {
      var on = bmHas(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    r.querySelectorAll('.ws-like-btn').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      var c = lkCount(h);
      btn.classList.toggle('is-active', c > 0);
      btn.setAttribute('aria-pressed', c > 0 ? 'true' : 'false');
      var span = btn.querySelector('.ws-like-badge');
      if (span) span.textContent = lkText(c);
    });
  }

  /* ---------- Klicks ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // Bookmark
    var bm = e.target.closest('.ws-bookmark-btn');
    if (bm) {
      e.preventDefault(); e.stopPropagation();
      var bh = bm.getAttribute('data-handle');
      if (!bh) return;
      var added = bmToggle(bh);
      document.querySelectorAll('.ws-bookmark-btn[data-handle="' + cssEsc(bh) + '"]').forEach(function (b) {
        b.classList.toggle('is-active', added);
        b.setAttribute('aria-pressed', added ? 'true' : 'false');
      });
      flash(bm);
      if (!added) {
        var wl = bm.closest('.ws-wl-card'); // auf der Merkliste-Seite Karte entfernen
        if (wl) { wl.parentNode && wl.parentNode.removeChild(wl); if (!bmGet().length) renderWishlist(); }
        var mc = bm.closest('.ws-bm-item'); // im Modal Eintrag entfernen
        if (mc) { mc.parentNode && mc.parentNode.removeChild(mc); renderModalEmptyState(); }
      } else {
        openModal(); // beim Merken Modal kurz zeigen
      }
      return;
    }

    // Like
    var lk = e.target.closest('.ws-like-btn');
    if (lk) {
      e.preventDefault(); e.stopPropagation();
      var lh = lk.getAttribute('data-handle');
      if (!lh) return;
      var liked = lkToggle(lh);
      var c = lkCount(lh);
      document.querySelectorAll('.ws-like-btn[data-handle="' + cssEsc(lh) + '"]').forEach(function (b) {
        b.classList.toggle('is-active', liked);
        b.setAttribute('aria-pressed', liked ? 'true' : 'false');
        var s = b.querySelector('.ws-like-badge');
        if (s) s.textContent = lkText(c);
      });
      flash(lk);
      return;
    }

    // Header-Icon öffnet Modal
    var open = e.target.closest('[data-ws-bookmark-open]');
    if (open) { e.preventDefault(); openModal(); return; }

    // Modal schließen
    if (e.target.closest('[data-ws-bm-close]')) { e.preventDefault(); closeModal(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function cssEsc(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
  function flash(btn) { btn.style.transform = 'scale(1.25)'; setTimeout(function () { btn.style.transform = ''; }, 130); }

  /* ---------- Preisformat ---------- */
  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function imgSrc(p) {
    if (!p.featured_image) return '';
    return p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image;
  }

  /* ---------- Modal (Header) ---------- */
  function openModal() {
    var m = document.getElementById('ws-bm-modal');
    if (!m) return;
    m.hidden = false;
    document.documentElement.classList.add('ws-bm-open');
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    renderModal();
  }
  function closeModal() {
    var m = document.getElementById('ws-bm-modal');
    if (!m) return;
    m.classList.remove('is-open');
    document.documentElement.classList.remove('ws-bm-open');
    setTimeout(function () { m.hidden = true; }, 220);
  }
  function renderModalEmptyState() {
    var list = document.getElementById('ws-bm-modal-list');
    var empty = document.getElementById('ws-bm-modal-empty');
    var allBtn = document.getElementById('ws-bm-modal-all');
    var has = bmGet().length > 0;
    if (empty) empty.style.display = has ? 'none' : '';
    if (allBtn) allBtn.style.display = has ? '' : 'none';
    if (list) list.style.display = has ? '' : 'none';
  }
  function renderModal() {
    var list = document.getElementById('ws-bm-modal-list');
    if (!list) return;
    renderModalEmptyState();
    var handles = bmGet();
    list.innerHTML = '';
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var onSale = p.compare_at_price && p.compare_at_price > p.price;
          var price = (onSale ? '<s>' + money(p.compare_at_price) + '</s> ' : '') + '<b>' + money(p.price) + '</b>';
          var row = document.createElement('div');
          row.className = 'ws-bm-item';
          row.innerHTML =
            '<a class="ws-bm-item__link" href="/products/' + h + '">' +
              '<span class="ws-bm-item__media">' + (imgSrc(p) ? '<img src="' + imgSrc(p) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="ws-bm-item__info"><span class="ws-bm-item__title">' + p.title + '</span>' +
              '<span class="ws-bm-item__price">' + price + '</span></span>' +
            '</a>' +
            '<button type="button" class="ws-bookmark-btn is-active ws-bm-item__remove" data-handle="' + h + '" aria-label="Entfernen">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></button>';
          list.appendChild(row);
        })
        .catch(function () {});
    });
  }

  /* ---------- Merkliste-Seite ---------- */
  function renderWishlist() {
    var grid = document.getElementById('ws-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('ws-wishlist-empty');
    var list = bmGet();
    grid.innerHTML = '';
    if (!list.length) {
      if (empty) empty.style.display = '';
      grid.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.style.display = '';
    list.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = imgSrc(p);
          var onSale = p.compare_at_price && p.compare_at_price > p.price;
          var priceHtml = (onSale ? '<s>' + money(p.compare_at_price) + '</s> ' : '') + '<b>' + money(p.price) + '</b>';
          var bm = '<button type="button" class="ws-bookmark-btn is-active ws-wl-card__bm" data-handle="' + h + '" aria-label="Von der Merkliste entfernen" aria-pressed="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></button>';
          var el = document.createElement('div');
          el.className = 'ws-wl-card';
          el.innerHTML = bm +
            '<a href="/products/' + h + '"><div class="ws-wl-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="ws-wl-title">' + p.title + '</div>' +
            '<div class="ws-wl-price">' + priceHtml + '</div></a>';
          grid.appendChild(el);
        })
        .catch(function () {});
    });
  }

  /* ---------- Init ---------- */
  function init() {
    syncButtons();
    updateCounts();
    renderWishlist();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
